import React, { useEffect, useMemo, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const pad = (value) => String(value).padStart(2, '0');

const VoteX2Banner = ({ endDateMs, sx = {} }) => {
  const getRemainingTime = () => {
    if (!endDateMs) return null;
    const diff = endDateMs - Date.now();

    if (diff <= 0) {
      return null;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { hours, minutes, seconds };
  };

  const [remaining, setRemaining] = useState(getRemainingTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setRemaining(getRemainingTime());
    }, 1000);

    return () => clearInterval(timer);
  }, [endDateMs]);

  const countdownText = useMemo(() => {
    if (!remaining) {
      return 'Offre terminée';
    }
    return `${pad(remaining.hours)}h ${pad(remaining.minutes)}m ${pad(remaining.seconds)}s`;
  }, [remaining]);

  const formattedDate = useMemo(() => {
    if (!endDateMs) return '';
    return new Date(endDateMs).toLocaleString('fr-FR', {
      weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  }, [endDateMs]);

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, rgba(201, 206, 214, 0.18) 0%, rgba(255, 152, 0, 0.16) 60%, rgba(182, 122, 60, 0.2) 100%)',
        border: '2px solid rgba(201, 206, 214, 0.5)',
        borderRadius: 3,
        px: { xs: 2, md: 3 },
        py: 2,
        backdropFilter: 'blur(8px)',
        boxShadow: '0 10px 35px rgba(255, 152, 0, 0.25)',
        ...sx,
      }}
    >
      <Chip
        icon={<BoltIcon />}
        label="Bonus vote x2"
        sx={{
          mb: 1,
          fontWeight: 800,
          color: '#2B1300',
          background: 'linear-gradient(135deg, #C9CED6 0%, #A56D33 100%)',
          '& .MuiChip-icon': { color: '#2B1300' },
        }}
      />

      <Typography sx={{ color: '#FFF7D6', fontWeight: 800, fontSize: { xs: '1rem', md: '1.2rem' } }}>
        Ogrines doublées à chaque vote
      </Typography>

      <Typography sx={{ color: 'rgba(255, 247, 214, 0.9)', mt: 0.4, mb: 1.2, fontSize: { xs: '0.9rem', md: '0.98rem' } }}>
        Fin de l&apos;événement : {formattedDate} (heure de Paris)
      </Typography>

      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, px: 1.2, py: 0.8, borderRadius: 2, background: 'rgba(30, 12, 0, 0.35)', border: '1px solid rgba(201, 206, 214, 0.4)' }}>
        <AccessTimeIcon sx={{ color: '#C9CED6', fontSize: 18 }} />
        <Typography sx={{ color: '#C9CED6', fontWeight: 800, letterSpacing: 0.4 }}>
          {'Décompte'} : {countdownText}
        </Typography>
      </Box>
    </Box>
  );
};

export default VoteX2Banner;